import {
  IconAboutUs,
  IconAccountContact,
  IconAccountFaq,
  IconAccountPrivacyPolicy,
  IconAccountReturnRefund,
  IconAccountTerms,
  IconAccountWishlist,
  IconPaymentTabby,
  IconPaymentTamaraLarge,
  IconPaymentTamaraLargeArabic,
  IconPdpAmex,
  IconPdpApplePay,
  IconPdpMada,
  IconPdpMastercard,
  IconPdpVisa,
} from "@repo/assets/images";

export const LANG_COOKIE = "NEXT_LOCALE";

export const MAX_TOKEN_AGE_IN_MS = 60 * 1000 * 45; // 45 minutes

export const COUNTRY_CODE_PHONE_PREFIX = "+966";

export const desktopFallbackBannerImage =
  "/assets/images/category_fallback_banner_desktop.webp";

export const mobileFallbackBannerImage =
  "/assets/images/category_fallback_banner_mobile.webp";

export const FAVOURITE_LINK = [
  {
    id: 0,
    url: "/favourites",
    name: "favourites",
    label: "Favourites",
    icon: IconAccountWishlist,
  },
];

export const CMS_LINKS = [
  {
    id: 1,
    url: "/cms/about-us",
    name: "about-us",
    label: "About_Us",
    icon: IconAboutUs,
  },
  {
    id: 2,
    url: "/cms/contact-us",
    name: "contact-us",
    label: "Contact_Us",
    icon: IconAccountContact,
  },
  {
    id: 3,
    url: "/cms/terms",
    name: "terms",
    label: "Terms_Of_use",
    icon: IconAccountTerms,
  },
  {
    id: 4,
    url: "/cms/privacy-policy",
    name: "privacy-policy",
    label: "Privacy_Policy",
    icon: IconAccountPrivacyPolicy,
  },
  {
    id: 5,
    url: "/cms/refund-return",
    name: "refund-return",
    label: "Refund_And_Return",
    icon: IconAccountReturnRefund,
  },
  {
    id: 6,
    url: "/cms/faq",
    name: "faq",
    label: "FAQ",
    icon: IconAccountFaq,
  },
];

export const PAY_ASSURANCE = [
  {
    id: 1,
    label: "Mastercard",
    component: IconPdpMastercard,
  },
  {
    id: 2,
    label: "Visa",
    component: IconPdpVisa,
  },
  {
    id: 3,
    label: "Amex",
    component: IconPdpAmex,
  },
  {
    id: 4,
    label: "Apple Pay",
    component: IconPdpApplePay,
  },
  {
    id: 5,
    label: "Mada",
    component: IconPdpMada,
  },
  {
    id: 6,
    label: "TABBY",
    component: IconPaymentTabby,
  },
  {
    id: 7,
    label: "TAMARA",
    component: IconPaymentTamaraLarge,
    arabicComponent: IconPaymentTamaraLargeArabic,
  },
];
